import React from 'react';
import classes from './LinkPreview.module.scss';
import { GetLinkMetadataQuery } from '../../../models/graphql';
import { ReactComponent as NoImage } from '../../../assets/images/no-image-130.svg';
import classNames from 'classnames';
import { SocialNetworksEnum } from '../../../constants/social-networks';

export type LinkPreviewViewProps = {
  //
  metadata: GetLinkMetadataQuery['linkMetadata'][number] | undefined;
  networkMode?: SocialNetworksEnum;
};

export type LinkPreviewData = {
  link: string;
  title: string;
  description: string;
  image: string;
};

export const LinkPreviewView = (props: LinkPreviewViewProps): JSX.Element => {
  const { metadata, networkMode } = props;

  const data: LinkPreviewData = {
    link: metadata ? metadata.initialUrl : '',
    title: metadata ? metadata.openGraph?.title ?? metadata.twitterCard?.title ?? '' : '',
    description: metadata ? metadata.openGraph?.description ?? metadata.twitterCard?.description ?? '' : '',
    image: metadata ? metadata.openGraph?.image ?? metadata.twitterCard?.image ?? '' : ''
  };

  return (
    <div
      className={classNames(classes.LinkPreview, {
        [classes.LinkPreviewFacebook]: networkMode === SocialNetworksEnum.facebook
      })}>
      <div className={'grid-x'}>
        <div className={classNames('cell', classes.ImageWrapper)}>
          {data.image ? <img alt={data.title ?? 'no image'} src={data.image} className={classes.Image} /> : <NoImage />}
        </div>
        <div className={classNames('cell', 'auto')}>
          <div className={classNames(classes.GridYWrapper, 'grid-y', 'align-center')}>
            <div className={'grid-x'}>{data.link ? <div className={classes.LinkTitle}>{data.link}</div> : null}</div>
            <div className={'grid-x'}>{data.title ? <div className={classes.Title}>{data.title}</div> : null}</div>
            <div className={'grid-x'}>
              {data.description ? <div className={classes.Description}>{data.description}</div> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
